__webpack_require__.p = "https://ded-ps-prod.t-static.ru/projects/invest24/prod/635805ee2242f15a206afe75b833ce40db6439a4/_next/";